import { useParams, useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BookOpen, MapPin } from 'lucide-react';
import { useState } from 'react';

const UserProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [following, setFollowing] = useState(false);
  const [activeTab, setActiveTab] = useState('游记');

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-24 pb-20">
        <div className="h-[200px] rounded-card bg-gradient-to-r from-primary to-accent mb-16 relative shadow-card" />
        <div className="relative -mt-20 mb-8 flex flex-col md:flex-row items-center md:items-end gap-4 px-2">
          <Avatar className="w-24 h-24 border-4 border-white shadow-card">
            <AvatarFallback className="bg-primary text-white text-2xl font-bold">旅</AvatarFallback>
          </Avatar>
          <div className="flex-1 text-center md:text-left mb-2">
            <h1 className="text-2xl font-bold text-text-primary">旅行者{id}</h1>
            <p className="text-sm text-text-secondary mt-1">用脚步丈量世界，用镜头记录美好。</p>
          </div>
          <Button
            onClick={() => setFollowing(!following)}
            className={`rounded-btn px-6 ${following ? 'bg-white border border-primary text-primary hover:bg-primary-light' : 'bg-primary hover:bg-primary-hover text-white'}`}
          >
            {following ? '已关注' : '关注'}
          </Button>
        </div>

        <div className="grid grid-cols-3 gap-4 mb-8">
          <Card className="border-0 shadow-card rounded-card bg-white text-center cursor-pointer hover:shadow-hover transition-all" onClick={() => navigate('/travelogues')}>
            <CardContent className="p-4">
              <p className="text-2xl font-bold text-text-primary">12</p>
              <p className="text-xs text-text-secondary">游记</p>
            </CardContent>
          </Card>
          <Card className="border-0 shadow-card rounded-card bg-white text-center cursor-pointer hover:shadow-hover transition-all" onClick={() => navigate(`/user/${id}/followers`)}>
            <CardContent className="p-4">
              <p className="text-2xl font-bold text-text-primary">1.2k</p>
              <p className="text-xs text-text-secondary">粉丝</p>
            </CardContent>
          </Card>
          <Card className="border-0 shadow-card rounded-card bg-white text-center cursor-pointer hover:shadow-hover transition-all" onClick={() => navigate(`/user/${id}/following`)}>
            <CardContent className="p-4">
              <p className="text-2xl font-bold text-text-primary">58</p>
              <p className="text-xs text-text-secondary">关注</p>
            </CardContent>
          </Card>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="mb-6">
          <TabsList className="bg-white rounded-btn p-1 shadow-card">
            {['游记', '日记', '收藏'].map((t) => (
              <TabsTrigger key={t} value={t} className="rounded-btn px-4 data-[state=active]:bg-primary data-[state=active]:text-white">{t}</TabsTrigger>
            ))}
          </TabsList>
        </Tabs>

        {activeTab === '游记' && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {[1, 2, 3].map((i) => (
              <Card key={i} className="border-0 shadow-card rounded-card bg-white overflow-hidden cursor-pointer hover:shadow-hover transition-all" onClick={() => navigate(`/travelogue/${i}`)}>
                <div className="h-40 bg-bg-secondary relative">
                  <img src={`https://picsum.photos/seed/travel-scenery/600/400`} alt="" className="w-full h-full mx-auto object-cover" />
                </div>
                <CardContent className="p-4">
                  <p className="font-medium text-text-primary line-clamp-1">精彩的旅行游记 {i}</p>
                  <div className="flex items-center gap-1 mt-2 text-xs text-text-tertiary">
                    <MapPin className="w-3 h-3" /> 云南大理
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}

        {activeTab === '日记' && (
          <div className="space-y-4">
            {[1, 2].map((i) => (
              <Card key={i} className="border-0 shadow-card rounded-card bg-white hover:shadow-hover transition-all">
                <CardContent className="p-4">
                  <p className="text-sm text-text-primary leading-relaxed">今天去了很棒的地方，风景美如画，记录一下此刻的心情...</p>
                  <p className="text-xs text-text-tertiary mt-2">2024-01-0{i}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        )}

        {activeTab === '收藏' && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {[1, 2].map((i) => (
              <Card key={i} className="border-0 shadow-card rounded-card bg-white overflow-hidden hover:shadow-hover transition-all">
                <div className="h-40 bg-bg-secondary relative">
                  <img src={`https://picsum.photos/seed/destination/600/400`} alt="" className="w-full h-full mx-auto object-cover" />
                </div>
                <CardContent className="p-4">
                  <p className="font-medium text-text-primary">收藏的行程 {i}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
